<div *ngIf="officeDetail" class="office">
  <app-office [office]="officeDetail.office" />
</div>
<div *ngIf="!officeDetail">No prescriber office in supplemental data</div>
